// extracted by mini-css-extract-plugin
export default {"outer-arrow-wrap-wrap":"index_outer-arrow-wrap-wrap__XUT4a"};